
import { EditorState, Modifier, SelectionState } from 'draft-js';

/**
 * 如果 block 是 Atomic Block，获取其 entity 信息
 * @param {Draft.ContentBlock} block
 * @param {DraftEditorStore} store
 */
export function getAtomicEntityInfo(block, store) {
	// 获取 Atomic Block 的 Entity 信息
	const entityKey = block.getEntityAt(0);
	const entity = entityKey ? store.getEditorState().getCurrentContent().getEntity(entityKey) : null;
	const entityType = entity ? entity.getType().toUpperCase() : null;
	const entityData = entity ? entity.getData() : null;

	return {
		entityKey,
		entityType,
		entityData,
	};
}



// WEBPACK FOOTER //
// ./lib/helpers/getAtomicEntityInfo.js